import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Shape from '../../images/s-shape.png';
import SectionTitle from '../SectionTitle/SectionTitle';

const SubscribeSectionS2 = () => {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');

    const validateEmail = (value) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateEmail(email)) {
            setError('');
        } else {
            setError(t('subscribe.errors.emailInvalid'));
        }
    };

    return (
        <section className="wpo-subscribe-section-s2 section-padding">
            <div className="container">
                <div className="wpo-subscribe-main">
                    <div className="row align-items-center">
                        <div className="col-lg-4">
                            <SectionTitle subtitle={t('subscribe.subtitle')} title={t('subscribe.title')} />
                        </div>
                        <div className="col-lg-8">
                            <div className="wpo-subscribe-wrap">
                                <form onSubmit={handleSubmit}>
                                    <div className="form-field">
                                        <input
                                            className="form-control"
                                            type="email"
                                            placeholder={t('subscribe.email')}
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                        {error && <p>{error}</p>}
                                    </div>
                                    <div className="form-field s-btn">
                                        <button className="theme-btn" type="submit">
                                            {t('subscribe.button')}
                                        </button>
                                    </div>
                                </form>
                                <div className="s-shape">
                                    <img src={Shape} alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="s-shape">
                <img src={Shape} alt="" />
            </div>
        </section>
    );
};

export default SubscribeSectionS2;
